const multiUrl = process.env.NEXT_PUBLIC_MULTI_URL ?? process.env.NEXT_PUBLIC_API_URL;

export const config = {
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
  testnetChain: 'sepolia',
  brand: {
    brandName: process.env.NEXT_PUBLIC_BRAND_NAME ?? '[BRAND]',
    emailConfirmationLinkUrl: process.env.NEXT_PUBLIC_EMAIL_CONFIRMATION_LINK_URL,
    userResetLinkUrl: process.env.NEXT_PUBLIC_USER_RESET_PASSWORD_LINK_URL,
    referralLinkUrl: process.env.NEXT_PUBLIC_REFERRAL_LINK_URL,
    appLinkUrl: process.env.NEXT_PUBLIC_APP_URL,
    hqLinkUrl: process.env.NEXT_PUBLIC_HQ_URL,
    emailForgotPasswordLinkUrl:
      process.env.NEXT_PUBLIC_FORGOT_EMAIL_CONFIRMATION_LINK_URL,
  },
  core: {
    membershipServiceUrl:
      process.env.NEXT_PUBLIC_MEMBERSHIP_SERVICE ??
      `${process.env.NEXT_PUBLIC_API_URL}/membership`,
    messagingServiceUrl:
      process.env.NEXT_PUBLIC_MESSAGING_SERVICE ??
      `${process.env.NEXT_PUBLIC_API_URL}/messaging`,
    ethConnectUrl:
      process.env.NEXT_PUBLIC_ETHCONNECT_SERVICE ??
      `${process.env.NEXT_PUBLIC_API_URL}/ethconnect`,
    shoppingServiceUrl:
      process.env.NEXT_PUBLIC_SHOPPING_SERVICE ??
      `${process.env.NEXT_PUBLIC_API_URL}/shopping`,
    walletServiceUrl:
      process.env.NEXT_PUBLIC_WALLET_SERVICE ??
      `${process.env.NEXT_PUBLIC_API_URL}/wallet`,
    licensesServiceUrl:
      process.env.NEXT_PUBLIC_LICENSES_SERVICE ??
      `${process.env.NEXT_PUBLIC_API_URL}/licenses`,
    supportToolsServiceUrl:
      process.env.NEXT_PUBLIC_SUPPORTTOOLS_SERVICE ??
      `${process.env.NEXT_PUBLIC_API_URL}/supporttools`,
    rewardsServiceUrl:
      process.env.NEXT_PUBLIC_REWARDS_SERVICE ??
      `${process.env.NEXT_PUBLIC_API_URL}/rewards`,
    featureFlagsServiceUrl:
      process.env.NEXT_PUBLIC_FEATURE_FLAG_SERVICE ??
      `${process.env.NEXT_PUBLIC_API_URL}/feature-flags`,
    actionLogsServiceUrl:
      process.env.NEXT_PUBLIC_ACTION_LOGS_SERVICE ??
      `${process.env.NEXT_PUBLIC_API_URL}/action-log`,
    brandAmbassadorServiceUrl:
      process.env.NEXT_PUBLIC_BRAND_AMBASSADOR_SERVICE ??
      `${process.env.NEXT_PUBLIC_API_URL}/brand-ambassador`,
    ugUrl: process.env.NEXT_PUBLIC_UG_SERVICE ?? `${multiUrl}/ug`,
  },
  firebase: {
    appId: process.env.NEXT_PUBLIC_REACT_APP_FIREBASE_APP_ID,
    apiKey: process.env.NEXT_PUBLIC_REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseUrl: process.env.NEXT_PUBLIC_REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.NEXT_PUBLIC_REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    recaptchaKey: process.env.NEXT_PUBLIC_REACT_APP_FIREBASE_RECAPTCHA_KEY,
  },
  blockchain: {
    ledger: process.env.NEXT_PUBLIC_LEDGER_SERVICE,
    testnet: process.env.NEXT_PUBLIC_RPC_TESTNET_URL,
    infura: process.env.NEXT_PUBLIC_INFURA_KEY,
    etherscan: process.env.Next_PUBLIC_ETHERSCAN_URL,
  },
  stripe: {
    publishableKey: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
  },
  gtm: {
    id: process.env.NEXT_PUBLIC_GTM_ID,
  },
  marketingFunnel: {
    signup: process.env.NEXT_PUBLIC_MARKETING_FUNNEL,
    waitlist: process.env.NEXT_PUBLIC_MARKETING_WAITLIST,
    freeNode: process.env.NEXT_PUBLIC_MARKETING_FREE_NODES,
  },
  other: {
    googleAnalytics: process.env.NEXT_PUBLIC_REACT_APP_GOOGLE_ANALYTICS,
    fontawesomeAuthToken: process.env.FONTAWESOME_AUTH_TOKEN,
  },
};
